export default __webpack_public_path__ + "static/media/eyes_strikethrough.c156916f.svg";